import { Ellipsis, TooltipTrigger } from "@visiblethread/react-components";
import { getTanStackRowProps } from "components/ExcelTable/constants";
import Flex, { GAP_CLASS } from "components/Flex";
import { LockIcon } from "lucide-react";
import { bool, string } from "prop-types";

import classes from "./NameCell.module.scss";

const NameCell = ({ row }) => {
  const {
    default: isDefault,
    lockedByAnotherUser,
    lockedBy,
    name,
  } = row.original;
  return (
    <Flex
      className={classes.cell}
      gap={GAP_CLASS.GAP_300}
      justifyContent="space-between"
    >
      {lockedByAnotherUser && (
        <TooltipTrigger
          classes={classes.locked}
          content={`Watchwords list is locked by ${lockedBy}`}
        >
          <LockIcon size={16} />
        </TooltipTrigger>
      )}

      <Ellipsis classes={classes.name} text={name} />

      {isDefault && <span className={classes.default}>(Default)</span>}
    </Flex>
  );
};

NameCell.propTypes = {
  row: getTanStackRowProps({
    default: bool,
    name: string.isRequired,
  }),
};

export default NameCell;
